export default __webpack_public_path__ + "static/2-a86587ed24cb150bbaa0fbf3dc373362.png";